import React from 'react'
import ReactDOM from 'react-dom'
import cx from 'classnames'
import { Spring } from 'react-spring/renderprops.cjs'
import Image from '/js/views/shared/components/contentParticles/image'
import { Citations } from '/js/views/shared/components/citations'
import StoryOverlaySection from './storyOverlaySection'
import StoryBackground from '/img/svg/story-background'

class StoryOverlayContent extends React.Component {
  constructor(props) {
    super(props)

    this.childCards = new Map()
  }

  componentDidMount() {
    const { selectedCardSectionIndex, selectedCardCardIndex } = this.props
    if (selectedCardSectionIndex != null && selectedCardCardIndex != null) {
      setTimeout(() => {
        this.scrollToSelectedCardNode()
      }, 300)
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.selectedNavigationSectionIndex !=
      prevProps.selectedNavigationSectionIndex
    ) {
      this.scrollToSelectedNavigationSectionNode()
    }
  }

  scrollToSelectedNavigationSectionNode() {
    const { selectedNavigationSectionIndex, sectionNodes } = this.props
    const sectionNode = sectionNodes.get(selectedNavigationSectionIndex)

    ReactDOM.findDOMNode(sectionNode).scrollIntoView(true)
  }

  scrollToSelectedCardNode() {
    const { selectedCardSectionIndex, selectedCardCardIndex } = this.props
    const cardNodeId = `${selectedCardSectionIndex}-${selectedCardCardIndex}`
    const cardNode = this.childCards.get(cardNodeId)

    ReactDOM.findDOMNode(cardNode).scrollIntoView(true)
  }

  renderStoryOverlaySections() {
    const { story, theme, selectedStory, sectionNodes } = this.props

    return story.cards.map((section, index) => (
      <StoryOverlaySection
        content={section}
        theme={theme}
        selectedStory={selectedStory}
        key={`story-overlay-section-${index}`}
        ref={(section) => {
          sectionNodes.set(index, section)
        }}
        cardNodes={this.childCards}
        sectionIndex={index}
      />
    ))
  }

  render() {
    const { title, theme, story } = this.props
    const { subtitle, images, caption } = this.props.story

    return (
      <div className="h-full w-full overflow-y-scroll relative z-1">
        <StoryBackground className="absolute top-0 left-0 w-full lg:w-auto" />
        <div className="flex-grow px-35 lg:px-65 xl:pl-115 xl:pr-128 pt-65 pb-65 z-10 relative">
          <h2
            className={cx('mb-50', {
              'flex items-start justify-between': story.sdg,
            })}
          >
            <span>
              <Spring
                from={{ transform: 'translate3d(0,40px,0)', opacity: 0 }}
                to={{ transform: 'translate3d(0,0,0)', opacity: 1 }}
              >
                {(props) => (
                  <span
                    style={props}
                    className={`font-condensed uppercase text-18 xl:text-24 mb-5 block ${theme.textColor}`}
                  >
                    Stories
                  </span>
                )}
              </Spring>
              <span className="screenreader"> for </span>
              <Spring
                from={{ transform: 'translate3d(0,10px,0)', opacity: 0 }}
                to={{ transform: 'translate3d(0,0,0)', opacity: 1 }}
                config={{ tension: 280, friction: 120, delay: 500 }}
              >
                {(props) => (
                  <span
                    style={props}
                    className="block font-serif text-36 xl:text-48 tracking-tight leading-tight"
                  >
                    {title}
                  </span>
                )}
              </Spring>
            </span>
            {story.sdg &&
              story.sdg.map((icon, index) => {
                return (
                  <div
                    key={index}
                    className={cx({
                      'ml-10': index === 0 && story.sdg.length === 1,
                      'mr-10': index === 0 && story.sdg.length > 1,
                    })}
                  >
                    <a className="block" href="/appendix#un">
                      <Image key={index} images={icon} sdg />
                    </a>
                  </div>
                )
              })}
          </h2>
          {images && (
            <div className="mb-10">
              <Image images={images} />
            </div>
          )}
          {caption && (
            <p
              className="text-granite-gray mb-20"
              dangerouslySetInnerHTML={{ __html: caption }}
            />
          )}

          <Citations citations={story.citations} />
          {subtitle && <p className="text-24 mb-45">{subtitle}</p>}
          <Spring from={{ opacity: 0 }} to={{ opacity: 1 }}>
            {(props) => (
              <div style={props}>{this.renderStoryOverlaySections()}</div>
            )}
          </Spring>
        </div>
      </div>
    )
  }
}

export default StoryOverlayContent
